import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, share, switchMap, withLatestFrom } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { UnSyncedEdgesActions } from '@states/unsynced-edges/unsynced-edges.action-types';
import { SyncQueueService } from '../../services/sync-queue.service';
import { TranslateService } from '@ngx-translate/core';
import * as UnSyncedEdgesSelectors from '@states/unsynced-edges/unsynced-edges.selectors';
import { SharedActions } from '@states/shared/shared.action-types';

@Injectable()
export class UnSyncedEdgesEffects {
  constructor(
    private actions$: Actions,
    private store$: Store<AppState>,
    private syncQueueService: SyncQueueService,
    private translateService: TranslateService,
  ) {}

  getUnSyncedEdges$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UnSyncedEdgesActions.getUnSyncedEdges),
      switchMap(({ filters }) =>
        this.syncQueueService.getAllUnSyncedEdgesCommands(filters, 0).pipe(
          map((response) => UnSyncedEdgesActions.getUnSyncedEdgesSuccess({ items: response.items, total: response.total, page: 0 })),
          catchError((error) => {
            console.error('Error loading unsynced edges:', error);
            return [UnSyncedEdgesActions.getUnSyncedEdgesFail({ error })];
          }),
        ),
      ),
      share(),
    ),
  );

  loadMoreUnSyncedEdges$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UnSyncedEdgesActions.loadMoreUnSyncedEdges),
      withLatestFrom(
        this.store$.pipe(select(UnSyncedEdgesSelectors.selectFilters)),
        this.store$.pipe(select(UnSyncedEdgesSelectors.selectUnSyncedEdgesPage)),
      ),
      switchMap(([, filters, currentPage]) => {
        const nextPage = currentPage + 1;
        return this.syncQueueService.getAllUnSyncedEdgesCommands(filters, nextPage).pipe(
          map((response) => UnSyncedEdgesActions.getUnSyncedEdgesSuccess({ items: response.items, total: response.total, page: nextPage })),
          catchError((error) => {
            console.error('Error loading more unsynced edges:', error);
            return [UnSyncedEdgesActions.getUnSyncedEdgesFail({ error })];
          }),
        );
      }),
      share(),
    ),
  );

  getUnSyncedEdgesSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UnSyncedEdgesActions.getUnSyncedEdgesSuccess),
      map(() => UnSyncedEdgesActions.setInitialLoader({ loading: false })),
    ),
  );

  getUnSyncedEdgesFail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UnSyncedEdgesActions.getUnSyncedEdgesFail),
      map(() => UnSyncedEdgesActions.setInitialLoader({ loading: false })),
    ),
  );
} 